import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  Filter,
  TextInput,
  SelectInput,
  ReferenceField
} from 'react-admin';
import JsonField from 'fields/JsonField';
import {EVENT_TYPES, USER_EVENT_TYPES} from 'constants/types';
import Icon from '@material-ui/icons/Event';
import {CustomPagination} from "../common/pagination/CustomPagination";
import IPField from "fields/IPField";
import CustomSelectField from "fields/CustomSelectField";
import UserAliasField from "fields/UserAliasField";

const allTypeIds = Object.keys(EVENT_TYPES).map(id => ({id: +id, name: EVENT_TYPES[id]}));
const userTypeIds = Object.keys(USER_EVENT_TYPES).map(id => ({id: id, name: USER_EVENT_TYPES[id]}));

export const UserEventsIcon = Icon;

export const UserEventsFilter = ({consumer, ...props}) => (
  <Filter {...props}>
    {consumer !== 'users' && <TextInput label='User ID' source='user_id' alwaysOn/>}
    <SelectInput label='Type ID' source='type_id' choices={userTypeIds} alwaysOn/>
    <TextInput label='IP address' source='ip' alwaysOn/>
    <TextInput source='props' alwaysOn/>
  </Filter>
);

export const UserEventsGrid = ({consumer, permissions: p, ...props}) => (
  <Datagrid {...props}>
    <TextField source='id'/>
    <DateField source='created_at' showTime locales='uk-UA'/>
    <CustomSelectField source='type_id' choices={allTypeIds}/>
    {consumer !== 'users' && <ReferenceField label='User' source='user_id' reference='users' allowEmpty={true}>
      <UserAliasField/>
    </ReferenceField>}
    <IPField source='ip'/>
    <TextField source='hostname'/>
    <JsonField source='props' sortable={false}/>
    <ReferenceField label='Admin' source='props.admin_id' reference='users' allowEmpty={true}>
      <UserAliasField/>
    </ReferenceField>
  </Datagrid>
);

export const userEventsListProps = {
  sort: {field: 'id', order: 'desc'},
  pagination: <CustomPagination/>,
  perPage: 50,
};

const UserEventsList = ({permissions, ...props}) => (
  <List
    title='User events'
    {...props}
    {...userEventsListProps}
    filters={<UserEventsFilter/>}
    bulkActionButtons={false}
  >
    <UserEventsGrid permissions={permissions}/>
  </List>
);

export default UserEventsList;
